export class TaskModel {
  tasks: string[] = [];
  notes = '';
}
